export const GEMINI_API_KEY = "AIzaSyC48KquSlFlGpy6oES12dOCohBkAXBC10w";